import {AnyAction, Reducer} from "redux";
// import {IViewPort} from "../types";
import {ACTION_TYPES} from "../actions";

/**
 *
 * reducer for ui state
 *
 * */

const userType = {
    admin: 'admin',
    query: 'query',
    public: 'public'
}

const userRoles: {[key: string]: string} = {
    frankrom_admin: 'admin',
    frankrom_public: 'public',
    frankrom_query: 'query'
}

const initialState = {
    activeTool: undefined, //current tool
    userType: userType.public,
    showLayerList: true,
    isEditing: false,
    editMode: ''
};

type IUIState = typeof initialState;

const reducer: Reducer<IUIState> = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.TOGGLE_LAYER_LIST:
            return toggleLayerList(state, action);
        case ACTION_TYPES.TOGGLE_CONTACT_TABLE:
            return toggleContactTable(state, action);
        case ACTION_TYPES.SET_EDITING:
            return setEditing(state, action);
        case ACTION_TYPES.SET_USER_INFO:
            return setUserInfo(state, action);
        default: {
            return state
        }
    }
};

//aud: "postgraphile"
// exp: 1557811069
// iat: 1557206269
// is_admin: null
// iss: "postgraphile"
// person_id: 9
// role: "frankrom_admin"
// username: "admin@cono.com"
function setUserInfo (state: IUIState, action: AnyAction) {
    let {username, role, exp, is_admin} = action.payload;
    const _userType: string = userRoles[role] || userType.public;
    return {...state, username, userType: _userType, exp, is_admin};
}

function setEditing (state: IUIState, action: AnyAction) {
    let {isEditing, editMode} = action.payload;
    if (!isEditing) {
        editMode = '';
    }
    return {...state, isEditing, editMode};
}

function toggleContactTable (state: IUIState, action: AnyAction) {
    const showTable = action.payload;
    const showLayerList = false;
    return {...state, showTable, showLayerList}
}

function toggleLayerList (state: IUIState, action: AnyAction) {
    const showLayerList = action.payload;
    const showTable = false;
    return {...state, showLayerList, showTable}
}

export { reducer as UIReducer };
